import { useEffect, useState } from 'react';
import {
  getIndicatorsByType,
  resolveIndicator,
  INDICATORS_CHANGED_EVENT,
} from '../services/next/indicatorsService';
import { Indicator } from '../types/next';

const useIndicators = (autoRefresh: boolean = false) => {
  const [indicators, setIndicators] = useState<Indicator[]>([]);

  const loadIndicators = async () => {
    try {
      const loaded = await getIndicatorsByType();
      setIndicators(loaded || []);
    } catch (e) {
      // Keep the last known indicators; the next poll retries
      console.error(e);
    }
  };

  const forceRefresh = async () => {
    await loadIndicators();
  };

  const done = async (id: number) => {
    await resolveIndicator(id);
    await loadIndicators();
  };

  useEffect(() => {
    loadIndicators();

    // A chat was read somewhere on the page: refresh now instead of waiting for the next poll
    window.addEventListener(INDICATORS_CHANGED_EVENT, loadIndicators);

    const indicatorsInterval = autoRefresh ? setInterval(loadIndicators, 10000) : undefined;

    return () => {
      window.removeEventListener(INDICATORS_CHANGED_EVENT, loadIndicators);
      if (indicatorsInterval) {
        clearInterval(indicatorsInterval);
      }
    };
  }, [autoRefresh]);

  return { indicators, forceRefresh, done };
};

export default useIndicators;
